import { observer } from "mobx-react";
import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import TimelinePageStore from "pages/TimelinePage/store/TimelinePageStore";
import { Grid } from "@mui/material";
import TopPeriodButton from "pages/TimelineGraphPage/component/TopPeriodButton";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {},
};

interface Props {
  pageStore: TimelinePageStore;
}
function TimelineGraphView(props: Props) {
  React.useEffect(() => {
    props.pageStore.fetchChartData(props.pageStore.period);
  }, []);

  const data = {
    labels: props.pageStore.labels,
    datasets: [
      {
        label: "평균 평가 점수",
        data: props.pageStore.scores,
        fill: false,
        borderColor: "#2281D0",
        tension: 0.1,
      },
    ],
  };

  return (
    <Grid>
      <TopPeriodButton pageStore={props.pageStore} />
      <Line options={options} data={data} />
    </Grid>
  );
}

export default observer(TimelineGraphView);
